import React, { useState } from "react";
import "./lens.css";

function Lens() {
  // Initial Lens Categories with products
  const initialLensCategories = {
    "Single Vision Lens": [
      // { id: 1, name: "Lens A", brand: "Brand X", price: 1500, image: "image1.jpg" },
      // { id: 2, name: "Lens B", brand: "Brand Y", price: 1200, image: "image2.jpg" },
      // { id: 3, name: "Lens C", brand: "Brand Z", price: 1800, image: "image3.jpg" },
      // { id: 4, name: "Lens D", brand: "Brand W", price: 2000, image: "image4.jpg" },
      // { id: 5, name: "Lens E", brand: "Brand V", price: 1600, image: "image5.jpg" },
      // { id: 6, name: "Lens F", brand: "Brand U", price: 1400, image: "image6.jpg" },
      // { id: 7, name: "Lens A", brand: "Brand X", price: 1500, image: "image1.jpg" },
      // { id: 8, name: "Lens B", brand: "Brand Y", price: 1200, image: "image2.jpg" },
      // { id: 9, name: "Lens C", brand: "Brand Z", price: 1800, image: "image3.jpg" },
  
    ],

    "Bifocal Lens": [
      // { id: 19, name: "Lens M", brand: "Brand N", price: 3000, image: "image13.jpg" },
      // { id: 20, name: "Lens N", brand: "Brand M", price: 3200, image: "image14.jpg" },
      // { id: 21, name: "Lens O", brand: "Brand L", price: 2800, image: "image15.jpg" },
      // { id: 22, name: "Lens P", brand: "Brand K", price: 3100, image: "image16.jpg" },
      // { id: 23, name: "Lens Q", brand: "Brand J", price: 2900, image: "image17.jpg" },
      // { id: 24, name: "Lens R", brand: "Brand I", price: 3400, image: "image18.jpg" },
      // { id: 25, name: "Lens P", brand: "Brand K", price: 3100, image: "image16.jpg" },
      // { id: 26, name: "Lens Q", brand: "Brand J", price: 2900, image: "image17.jpg" },
      // { id: 27, name: "Lens R", brand: "Brand I", price: 3400, image: "image18.jpg" },
    ],

    "Progressive Lens": [
      // { id: 30, name: "Lens G", brand: "Brand T", price: 2500, image: "image7.jpg" },
      // { id: 31, name: "Lens H", brand: "Brand S", price: 2200, image: "image8.jpg" },
      // { id: 12, name: "Lens I", brand: "Brand R", price: 2800, image: "image9.jpg" },
      // { id: 33, name: "Lens J", brand: "Brand Q", price: 2400, image: "image10.jpg" },
      // { id: 34, name: "Lens K", brand: "Brand P", price: 2600, image: "image11.jpg" },
      // { id: 35, name: "Lens L", brand: "Brand O", price: 2300, image: "image12.jpg" },
      // { id: 36, name: "Lens J", brand: "Brand Q", price: 2400, image: "image10.jpg" },
      // { id: 37, name: "Lens K", brand: "Brand P", price: 2600, image: "image11.jpg" },
      // { id: 38, name: "Lens L", brand: "Brand O", price: 2300, image: "image12.jpg" },
    ],

    "Bluefilter": [
      // { id: 41, name: "Single Vision Lens 1", brand: "VisionPro", price: 5000, image: "/single-vision1.jpg" },
      // { id: 42, name: "Single Vision Lens 2", brand: "OptiLens", price: 5200, image: "/single-vision2.jpg" },
      // { id: 43, name: "Single Vision Lens 3", brand: "ClearView", price: 5300, image: "/single-vision3.jpg" },
      // { id: 44, name: "Single Vision Lens 4", brand: "LensMaster", price: 5400, image: "/single-vision4.jpg" },
      // { id: 45, name: "Single Vision Lens 5", brand: "BlueGuard", price: 5500, image: "/single-vision5.jpg" },
      // { id: 46, name: "Single Vision Lens 6", brand: "GlareFree", price: 5600, image: "/single-vision6.jpg" },
      // { id: 47, name: "Single Vision Lens 7", brand: "SunAdaptive", price: 5700, image: "/single-vision7.jpg" },
      // { id: 48, name: "Single Vision Lens 8", brand: "VisionPro", price: 5800, image: "/single-vision8.jpg" },
      // { id: 49, name: "Single Vision Lens 9", brand: "OptiLens", price: 5900, image: "/single-vision9.jpg" },
      // { id: 50, name: "Single Vision Lens 10", brand: "ClearView", price: 6000, image: "/single-vision10.jpg" },
      // { id: 51, name: "Single Vision Lens 11", brand: "LensMaster", price: 6100, image: "/single-vision11.jpg" },
      // { id: 52, name: "Single Vision Lens 12", brand: "BlueGuard", price: 6200, image: "/single-vision12.jpg" },
    ],

    "Anti Reflective": [
      // { id: 61, name: "Single Vision Lens 1", brand: "VisionPro", price: 5000, image: "/single-vision1.jpg" },
      // { id: 62, name: "Single Vision Lens 2", brand: "OptiLens", price: 5200, image: "/single-vision2.jpg" },
      // { id: 63, name: "Single Vision Lens 3", brand: "ClearView", price: 5300, image: "/single-vision3.jpg" },
      // { id: 64, name: "Single Vision Lens 4", brand: "LensMaster", price: 5400, image: "/single-vision4.jpg" },
      // { id: 65, name: "Single Vision Lens 5", brand: "BlueGuard", price: 5500, image: "/single-vision5.jpg" },
      // { id: 66, name: "Single Vision Lens 6", brand: "GlareFree", price: 5600, image: "/single-vision6.jpg" },
      // { id: 67, name: "Single Vision Lens 7", brand: "SunAdaptive", price: 5700, image: "/single-vision7.jpg" },
      // { id: 68, name: "Single Vision Lens 8", brand: "VisionPro", price: 5800, image: "/single-vision8.jpg" },
      // { id: 69, name: "Single Vision Lens 9", brand: "OptiLens", price: 5900, image: "/single-vision9.jpg" },
      // { id: 70, name: "Single Vision Lens 10", brand: "ClearView", price: 6000, image: "/single-vision10.jpg" },
      // { id: 71, name: "Single Vision Lens 11", brand: "LensMaster", price: 6100, image: "/single-vision11.jpg" },
      // { id: 72, name: "Single Vision Lens 12", brand: "BlueGuard", price: 6200, image: "/single-vision12.jpg" },
    ],

    "Photochrome": [
      // { id: 81, name: "Single Vision Lens 1", brand: "VisionPro", price: 5000, image: "/single-vision1.jpg" },
      // { id: 82, name: "Single Vision Lens 2", brand: "OptiLens", price: 5200, image: "/single-vision2.jpg" },
      // { id: 83, name: "Single Vision Lens 3", brand: "ClearView", price: 5300, image: "/single-vision3.jpg" },
      // { id: 84, name: "Single Vision Lens 4", brand: "LensMaster", price: 5400, image: "/single-vision4.jpg" },
      // { id: 85, name: "Single Vision Lens 5", brand: "BlueGuard", price: 5500, image: "/single-vision5.jpg" },
      // { id: 86, name: "Single Vision Lens 6", brand: "GlareFree", price: 5600, image: "/single-vision6.jpg" },
      // { id: 87, name: "Single Vision Lens 7", brand: "SunAdaptive", price: 5700, image: "/single-vision7.jpg" },
      // { id: 88, name: "Single Vision Lens 8", brand: "VisionPro", price: 5800, image: "/single-vision8.jpg" },
      // { id: 89, name: "Single Vision Lens 9", brand: "OptiLens", price: 5900, image: "/single-vision9.jpg" },
      // { id: 90, name: "Single Vision Lens 10", brand: "ClearView", price: 6000, image: "/single-vision10.jpg" },
      // { id: 91, name: "Single Vision Lens 11", brand: "LensMaster", price: 6100, image: "/single-vision11.jpg" },
      // { id: 92, name: "Single Vision Lens 12", brand: "BlueGuard", price: 6200, image: "/single-vision12.jpg" },
    ],
  };


  const SingleVisionLens = [
    "Single vision lenses are designed to correct one field of vision, whether for distance or reading. These lenses are perfect for people who need help with either near or far sight but not both. If you're looking for clear vision all day long without switching between different pairs of glasses, single vision lenses are the ideal choice. Explore Eye Care Optical and Clinic’s online eyewear store for a wide range of stylish frames to match your needs.",
    "Whether you're reading a book, working on a computer, or enjoying outdoor activities, single vision lenses provide consistent, sharp vision for your specific needs. With a variety of frame options available, you can find the perfect pair that suits your lifestyle and personality. Visit Eye Care Optical and Clinic today to find your perfect pair of single vision lenses.",
    "Single vision lenses are a simple yet effective solution for those who require prescription glasses. Whether you need them for distance or reading, these lenses offer clear, crisp vision. Visit Eye Care Optical and Clinic for a wide range of frames and lenses that can be customized to your prescription for both comfort and style.",
    "Tired of constantly switching between different pairs of glasses? Single vision lenses are here to simplify your life! With a pair of single vision glasses, you'll have the perfect prescription for distance or reading at all times. Browse Eye Care Optical and Clinic’s online store for the latest frames and designs for your new pair of glasses."
  ];
  

  const Bifocallens = [
    "Bifocal lenses are a great option for those who need help seeing clearly both near and far. With bifocals, you don’t need separate glasses for different activities. These lenses provide two different prescriptions in one lens—one for distance vision and one for near vision. Explore Eye Care Optical and Clinic’s collection of stylish frames that can be paired with bifocal lenses for both convenience and fashion.",
    "If you need glasses for both reading and distance, bifocal lenses are the perfect solution. The upper part of the lens is for distance vision, while the lower part is for reading or close-up tasks. With bifocals, you’ll enjoy seamless transitions between distances, making them ideal for active individuals. Check out Eye Care Optical and Clinic for a variety of bifocal frames to suit your personal style.",
    "Bifocals offer clear vision for both near and far distances, eliminating the need to switch between different pairs of glasses. Whether you’re at work, reading, or driving, bifocals will provide you with the clarity you need. Eye Care Optical and Clinic offers a wide selection of stylish bifocal glasses that can be customized to your prescription.",
    "Say goodbye to the hassle of carrying around multiple pairs of glasses! Bifocal lenses allow you to see clearly both up close and at a distance with a single pair of glasses. Visit Eye Care Optical and Clinic today to find a wide selection of frames and bifocal lenses to suit your needs and style."
  ];
  

  const ProgressiveLens = [
    "Progressive lenses are the perfect solution for individuals who need vision correction for both near and far distances without the visible lines of bifocals. These lenses provide a seamless transition from distance vision to reading, making them ideal for those who don’t want to switch between different pairs of glasses. Explore Eye Care Optical and Clinic for progressive lenses in a variety of stylish frames.",
    "With progressive lenses, you get all the benefits of bifocals and single vision lenses without the lines. They provide a smooth and gradual transition from far vision to near vision. This is the perfect option for people who need help with all distances but want a more natural and aesthetically pleasing solution. Visit Eye Care Optical and Clinic for progressive lenses that can be customized to your prescription.",
    "Tired of the lines on traditional bifocal lenses? Progressive lenses offer a more natural transition between near, intermediate, and far vision, making them an excellent option for those who need all-in-one vision correction. Find the perfect pair of progressive lenses with stylish frames at Eye Care Optical and Clinic.",
    "Progressive lenses provide the freedom to see clearly at all distances without having to switch between different pairs of glasses. Whether you're reading a book, working on the computer, or driving, these lenses will provide clarity. Check out Eye Care Optical and Clinic for a selection of frames and progressive lenses that fit your lifestyle."
  ];
  

  const Bluefilter = [
    "Blue light filtering lenses are designed to block harmful blue light emitted from screens, helping reduce eye strain and discomfort. If you spend long hours in front of a computer or mobile device, blue light filtering lenses can help protect your eyes and improve comfort. Explore Eye Care Optical and Clinic’s range of frames and blue light filter lenses to enhance your screen time experience.",
    "Blue light from digital devices can cause eye strain and disrupt your sleep. Blue light filtering lenses reduce this exposure, providing comfort and protection while you work or play. Visit Eye Care Optical and Clinic to find stylish frames with blue light filtering lenses that fit your needs.",
    "Protect your eyes from the harmful effects of prolonged screen time with blue light filtering lenses. These lenses help to reduce eye fatigue and improve sleep quality, making them perfect for those who spend hours working on computers, phones, or tablets. Browse Eye Care Optical and Clinic’s online store for frames with blue light filters.",
    "Blue light filtering lenses are essential for modern life, reducing the strain caused by long hours on digital devices. With these lenses, you can enjoy your screen time without discomfort or disruption to your sleep. Find your perfect pair at Eye Care Optical and Clinic today."
  ];
  

  const AntiReflective = [
    "Anti-reflective lenses are designed to reduce glare and reflections from digital screens, headlights, and ambient light. With anti-reflective lenses, you’ll experience clearer vision and less strain on your eyes, especially in bright lighting conditions. Eye Care Optical and Clinic offers a variety of anti-reflective lenses that can be paired with stylish frames for maximum comfort and clarity.",
    "Say goodbye to glare and reflections with anti-reflective lenses. These lenses reduce unwanted light reflections, allowing you to see clearly in any lighting. Whether you're driving at night or working on a computer, anti-reflective lenses improve your vision and comfort. Check out Eye Care Optical and Clinic for high-quality frames and anti-reflective lenses.",
    "Anti-reflective lenses are ideal for reducing glare and reflections from screens, sunlight, and artificial lights. These lenses enhance your vision and help you see more clearly, especially in bright or low-light environments. Visit Eye Care Optical and Clinic today to find the perfect pair of anti-reflective lenses for your needs.",
    "Experience sharper vision and reduced glare with anti-reflective lenses. These lenses are designed to improve your vision and comfort in challenging lighting conditions. Whether you're on the road or in front of a screen, Eye Care Optical and Clinic’s anti-reflective lenses offer a clear, distortion-free visual experience."
  ];
  

  const Photochrome = [
    "Photochromic lenses are perfect for those who need both corrective lenses and protection from UV rays. These lenses darken when exposed to sunlight and return to clear indoors, giving you the flexibility of sunglasses and prescription glasses in one pair. Explore Eye Care Optical and Clinic’s collection of photochromic lenses for a convenient and stylish eyewear solution.",
    "Photochromic lenses provide the convenience of both prescription glasses and sunglasses in one. These lenses automatically adjust to changing light conditions, darkening in the sun and clearing up indoors. Visit Eye Care Optical and Clinic to find photochromic lenses that protect your eyes and provide clear vision in all lighting.",
    "With photochromic lenses, you no longer need to carry around multiple pairs of glasses. These lenses transition from clear to dark in response to sunlight, offering both vision correction and UV protection. Discover the convenience and comfort of photochromic lenses at Eye Care Optical and Clinic.",
    "Photochromic lenses are an ideal solution for those who want the benefits of both prescription glasses and sunglasses. These lenses change their tint based on the light, giving you clear vision indoors and protection outdoors. Find the perfect pair at Eye Care Optical and Clinic today."
  ];
   

// Load cart from localStorage on initial render
// const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cart")) || []);

// const handleAddToCart = (product) => {
//   const existingProduct = cart.find(item => item.id === product.id);
//   if (existingProduct) {
//     const updatedCart = cart.map(item =>
//       item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
//     );
//     setCart(updatedCart);
//     localStorage.setItem("cart", JSON.stringify(updatedCart));
//   } else {
//     const newCart = [...cart, { ...product, quantity: 1 }];
//     setCart(newCart);
//     localStorage.setItem("cart", JSON.stringify(newCart));
//   }
  
//   // Show alert when product is added
//   alert(`${product.name} has been added to the cart!`);
// };

const [currentCategory, setCurrentCategory] = useState("Single Vision Lens");
// const [currentPage, setCurrentPage] = useState(1);
// const [sortOption, setSortOption] = useState("");

// // Pagination logic
// const itemsPerPage = 6;
// const currentCategoryItems = initialLensCategories[currentCategory] || [];

// //Sort the items based on the selected sort option
// const sortedItems = [...currentCategoryItems].sort((a, b) => {
//   if (sortOption === "price-asc") return a.price - b.price;
//   if (sortOption === "price-desc") return b.price - a.price;
//   return 0; // No sorting
// });

// const totalPages = Math.ceil(sortedItems.length / itemsPerPage);
// const displayedItems = sortedItems.slice(
//   (currentPage - 1) * itemsPerPage,
//   currentPage * itemsPerPage
// );

// Change category handler
const handleCategoryChange = (category) => {
  setCurrentCategory(category);
  // setCurrentPage(1);
};

return (
  <div className="lens-container">
    <h1 className="lens-title">Explore Our Lens Categories</h1>

    {/* Category Navigation */}
    <div className="category-navigation">
      {Object.keys(initialLensCategories).map((category) => (
        <button
          key={category}
          className={`category-button ${category === currentCategory ? "active" : ""}`}
          onClick={() => handleCategoryChange(category)}
        >
          {category}
        </button>
      ))}
    </div>

    {/* Sorting Dropdown */}
    {/* <div className="sorting-dropdown">
      <label htmlFor="sort-select">Sort by:</label>
      <select
        id="sort-select"
        className="sort-select"
        value={sortOption}
        onChange={(e) => setSortOption(e.target.value)}
      >
        <option value="">Default</option>
        <option value="price-asc">Price: Low to High</option>
        <option value="price-desc">Price: High to Low</option>
      </select>
    </div> */}



    {currentCategory === "Single Vision Lens" && (
        <div className="single-vision-description">
          <h2></h2>
          <ul>
            {SingleVisionLens.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}

{currentCategory === "Bifocal Lens" && (
        <div className="bifocal-lens-description">
          <h2></h2>
          <ul>
            {Bifocallens.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}

{currentCategory === "Progressive Lens" && (
        <div className="progressive-lens-description">
          <h2></h2>
          <ul>
            {ProgressiveLens.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}


{currentCategory === "Bluefilter" && (
        <div className="bluefilter-description">
          <h2></h2>
          <ul>
            {Bluefilter.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}


{currentCategory === "Anti Reflective" && (
        <div className="anti-reflective-description">
          <h2></h2>
          <ul>
            {AntiReflective.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}


{currentCategory === "Photochrome" && (
        <div className="photochrome-description">
          <h2></h2>
          <ul>
            {Photochrome.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}

    {/* Lens Grid */}
    {/* <div className="lens-grid">
      {displayedItems.map((lens) => (
        <div key={lens.id} className="lens-item">
          <img src={lens.image} alt={lens.name} className="lens-image" />
          <p className="lens-name">Name: {lens.name}</p>
          <p className="lens-brand">Brand: {lens.brand}</p>
          <p className="lens-price">Price: Rs {lens.price.toLocaleString()}</p>
          <button
            className="add-to-cart-button"
            onClick={() => handleAddToCart(lens)}
          >
            Add to Cart
          </button>
        </div>
      ))}
    </div> */}

   
    {/* <div className="pagination-controls">
      <button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(currentPage - 1)}
        className="pagination-button"
      >
        &lt;
      </button>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <button
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage(currentPage + 1)}
        className="pagination-button"
      >
        &gt;
      </button>
    </div> */}

  </div>
);
}

export default Lens;